<template>
  <BaseCard title="Statistik Login" description="Statistik Login Pengguna">
    <template #action>
      <BaseInput type="date" :shadow="false" v-model="filter.date" @change="loadStats" />
    </template>
    <div class="border-t pt-5">
      <LineChart ref="line" :chart-data="stats" :chart-options="options" />
    </div>

    <LoginStatsDetail :visible="detailModal.visible" :hour="detailModal.hour" :date="filter.date" @close="detailModal.visible = false" />
  </BaseCard>
</template>

<script>
import dayjs from 'dayjs';
import { Line } from 'vue-chartjs';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
} from 'chart.js';
import { requestMixin } from '../../../mixins/request/request';
import LoginStatsDetail from './LoginStatsDetail.vue';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip
);

export default {
  mixins: [requestMixin],
  components: { LineChart: Line, LoginStatsDetail },
  data() {
    return {
      detailModal: {
        hour: null,
        visible: false
      },
      filter: {
        date: dayjs().format('YYYY-MM-DD')
      },
      loginStats: [],
    };
  },
  computed: {
    stats() {
      return {
        labels: Array.from({ length: 24 }, (_, i) =>
          dayjs().set('hour', i).set('minute', 0).format('HH:mm')
        ),
        datasets: [
          {
            label: 'Total Login',
            data: this.loginStats,
            fill: true,
            backgroundColor: 'rgba(54, 162, 235, 0.2)',
            borderColor: 'rgba(54, 162, 235)',
          },
        ],
      };
    },
    options() {
      return {
        onClick: e => {
          const { chart } = e

          const points = chart.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true)

          if (points.length) {
            const [point] = points

            const label = chart.data.labels[point.index]

            this.openDetailStats(label)
          }
        }
      }
    }
  },
  methods: {
    async loadStats() {
      const [res, err] = await this.request(
        `/api/v1/users/-actions/login-stats`,
        {
          params: {
            from_date: dayjs(this.filter.date).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
            to_date: dayjs(this.filter.date).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          },
        }
      );

      if (!err) {
        this.loginStats = res;
      }
    },
    openDetailStats(hour) {
      this.detailModal.hour = hour
      this.detailModal.visible = true
    }
  },
  created() {
    this.loadStats();
  },
};
</script>
